import { useState } from "react";
import { Trash2 } from "lucide-react";
import { ProductSelect } from "@/components/load/ProductSelect";

export const NEW_CUSTOMER = { name: "", tanks: [{ name: "Regular Tank 1", product: "gas87" }, { name: "Diesel Tank", product: "ulsd" }] };

export const CustomerModal = ({ initial, isNew, onSave, onDelete, onClose, t }) => {
  const [name, setName] = useState(initial.name);
  const [tanks, setTanks] = useState(initial.tanks.map((x) => ({ ...x })));
  const [error, setError] = useState("");
  const setTank = (i, k, v) => { setError(""); setTanks(tanks.map((x, j) => (j === i ? { ...x, [k]: v } : x))); };
  const save = () => {
    if (!name.trim()) return setError(t("Give the customer a name."));
    if (tanks.some((x) => !x.name.trim())) return setError(t("Every tank needs a name."));
    onSave({ name: name.trim(), tanks: tanks.map((x) => ({ ...x, name: x.name.trim() })) });
  };
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal load-modal" onClick={(e) => e.stopPropagation()} data-testid="customer-modal">
        <div className="card-name">{isNew ? t("New customer") : t("Edit customer tanks")}</div>
        <div className="label">{t("Customer / store name")}</div>
        <input className="text-input" value={name} maxLength={60} placeholder="e.g. Wawa #1234" onChange={(e) => { setError(""); setName(e.target.value); }} data-testid="customer-name-input" />
        <div className="card-sub">{t("List each store tank and its product. Then type gallons per tank and each tank gets its own pockets.")}</div>
        {tanks.map((x, i) => (
          <div className="load-tank-row" key={i} data-testid={`tank-row-${i}`}>
            <input className="text-input" value={x.name} maxLength={40} onChange={(e) => setTank(i, "name", e.target.value)} data-testid={`tank-name-${i}`} />
            <ProductSelect value={x.product} onChange={(v) => setTank(i, "product", v)} testId={`tank-product-${i}`} />
            <button type="button" className="ghost-btn" aria-label={t("Remove")} disabled={tanks.length === 1} onClick={() => setTanks(tanks.filter((_, j) => j !== i))} data-testid={`tank-remove-${i}`}><Trash2 size={14} /></button>
          </div>
        ))}
        <button type="button" className="ghost-btn" disabled={tanks.length >= 12} onClick={() => setTanks([...tanks, { name: `Tank ${tanks.length + 1}`, product: "ulsd" }])} data-testid="add-tank-btn">+ {t("Add tank")}</button>
        {error && <div className="form-error" data-testid="customer-form-error">{error}</div>}
        <div className="modal-actions">
          {!isNew && <button type="button" className="ghost-btn danger-ghost load-left" onClick={onDelete} data-testid="delete-customer-btn">{t("Delete")}</button>}
          <button type="button" className="ghost-btn" onClick={onClose} data-testid="cancel-customer-btn">{t("Cancel")}</button>
          <button type="button" className="primary-btn" onClick={save} data-testid="save-customer-btn">{t("Save")}</button>
        </div>
      </div>
    </div>
  );
};
